import React, { useEffect, useState } from 'react';
import bizcourt from '../../assets/bizcourt.svg';
import BizAddNewCourt from '../BizAddNewCourt';
const BizManageCourt = () => {

  const [managpage , setManagpage] = useState( true)
  const [showcal , setShowcal] = useState( false)  

  return (
    <>  
    { managpage ? <div>
            <h1 className='text-2xl ml-3  text-[#272C34] font-bold'>Manage courts</h1>
            <div className='my-4 mx-2'>
            <div className='flex justify-between'>
                <div className='flex'>
                    <h5 className='text-[12px] text-[#272C34] my-1'>See bookings for</h5>
                    <select className='md:w-[18rem] w-[7rem] bg-[#FBFEFF] px-2 ml-3 h-[25px] text-xs border border-gray-300 rounded-lg'>
                        <option>All</option>
                        <option>ok</option>
                    </select>
                </div>
                <div>   <button className='rounded-2xl bg-[#409BF5] h-[30px] md:h-[45px] w-[130px] md:w-[196px] text-[12px] md:font-bold text-white ' onClick={()=> {setManagpage(false) ; setShowcal(true) ; } } >+ Add new court</button> </div>
            </div>
 
   
            </div>
               

               <div className='md:flex my-6'>
               <div className=' md:w-[30%] rounded-xl '>
                   <img src={bizcourt} alt='court img' className='w-full h-full ' /> 
               </div>
               <div className=' md:w-[70%] md:ml-3 '>
                   <div className='flex justify-between'>
                       <h5 className='md:text-2xl text-lg text-[#272C34] font-bold px-2 '>Padel Buddy Court name</h5>
                       <h5 className='md:text-2xl text-lg text-[#272C34] font-bold'>$64<span className='text-gray-400 text-[12px] '>/game/player</span></h5>
                   </div>
                   <div className='mx-2 '>
                   <h2 className='pt-2 text-[#272C34] text-[12px] font-bold'> Location </h2>
                   <p className='text-[#6A7D95] text-[12px] font-semibold '>12 ABC London , New York London.</p>
                   </div>
                   <div className='flex mx-2 md:pt-8 pt-3'>
                       <div className='h-9 w-9 rounded-full bg-red-100 text-center pt-[6px] cursor-pointer'><i class="fa-solid fa-trash text-[#EB5757] "></i></div>
                       <div className='h-9 w-9 rounded-full bg-blue-200 text-center pt-[6px] mx-2 cursor-pointer'><i class="fa-solid fa-pen text-blue-500"></i></div>
                       <div className='my-2 flex'>
            <p className='md:px-3 text-[#272C34] text-[12px] pt-1'>Available</p>
            <div class="relative mx-2 inline-block w-12 mr-2 align-middle select-none transition duration-200 ease-in">
    <input type="checkbox" name="toggle" id="toggle" class="toggle-checkbox absolute block w-6 h-6 rounded-full   border-4 appearance-none cursor-pointer"/>
    <label for="toggle" class="toggle-label block  overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"></label>
</div>
</div>
                   </div>
               </div>
               </div>


               
               <div className='md:flex my-6'>
               <div className=' md:w-[30%] rounded-xl '>
                   <img src={bizcourt} alt='court img' className='w-full h-full ' /> 
               </div>
               <div className=' md:w-[70%] md:ml-3 '>
                   <div className='flex justify-between'>
                       <h5 className='md:text-2xl text-lg text-[#272C34] font-bold px-2 '>Padel Buddy Court name</h5>
                       <h5 className='md:text-2xl text-lg text-[#272C34] font-bold'>$64<span className='text-gray-400 text-[12px] '>/game/player</span></h5>
                   </div>
                   <div className='mx-2 '>
                   <h2 className='pt-2 text-[#272C34] text-[12px] font-bold'> Location </h2>
                   <p className='text-[#6A7D95] text-[12px] font-semibold '>12 ABC London , New York London.</p>
                   </div>
                   <div className='flex mx-2 md:pt-8 pt-3'>
                       <div className='h-9 w-9 rounded-full bg-red-100 text-center pt-[6px] cursor-pointer'><i class="fa-solid fa-trash text-[#EB5757] "></i></div>
                       <div className='h-9 w-9 rounded-full bg-blue-200 text-center pt-[6px] mx-2 cursor-pointer'><i class="fa-solid fa-pen text-blue-500"></i></div>
                       <div className='my-2 flex'>
            <p className='md:px-3 text-[#272C34] text-[12px] pt-1'>Available</p>
            <div class="relative mx-2 inline-block w-12 mr-2 align-middle select-none transition duration-200 ease-in">
    <input type="checkbox" name="toggle" id="toggle" class="toggle-checkbox absolute block w-6 h-6 rounded-full   border-4 appearance-none cursor-pointer"/>
    <label for="toggle" class="toggle-label block  overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"></label>
</div>
</div>
                   </div>
               </div>
               </div>

               <div className='md:flex my-6'>
               <div className=' md:w-[30%] rounded-xl '>
                   <img src={bizcourt} alt='court img' className='w-full h-full ' /> 
               </div>
               <div className=' md:w-[70%] md:ml-3 '>
                   <div className='flex justify-between'>
                       <h5 className='md:text-2xl text-lg text-[#272C34] font-bold px-2 '>Padel Buddy Court name</h5>
                       <h5 className='md:text-2xl text-lg text-[#272C34] font-bold'>$64<span className='text-gray-400 text-[12px] '>/game/player</span></h5>
                   </div>
                   <div className='mx-2 '>
                   <h2 className='pt-2 text-[#272C34] text-[12px] font-bold'> Location </h2>
                   <p className='text-[#6A7D95] text-[12px] font-semibold '>12 ABC London , New York London.</p>
                   </div>
                   <div className='flex mx-2 md:pt-8 pt-3'>
                       <div className='h-9 w-9 rounded-full bg-red-100 text-center pt-[6px] cursor-pointer'><i class="fa-solid fa-trash text-[#EB5757] "></i></div>
                       <div className='h-9 w-9 rounded-full bg-blue-200 text-center pt-[6px] mx-2 cursor-pointer'><i class="fa-solid fa-pen text-blue-500"></i></div>
                       <div className='my-2 flex'>
            <p className='md:px-3 text-[#272C34] text-[12px] pt-1'>Available</p>
            <div class="relative mx-2 inline-block w-12 mr-2 align-middle select-none transition duration-200 ease-in">
    <input type="checkbox" name="toggle" id="toggle" class="toggle-checkbox absolute block w-6 h-6 rounded-full   border-4 appearance-none cursor-pointer"/>
    <label for="toggle" class="toggle-label block  overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"></label>
</div>
</div>
                   </div>
               </div>
               </div>

               <div className='md:flex my-6'>
               <div className=' md:w-[30%] rounded-xl '>
                   <img src={bizcourt} alt='court img' className='w-full h-full ' /> 
               </div>
               <div className=' md:w-[70%] md:ml-3 '>
                   <div className='flex justify-between'>
                       <h5 className='md:text-2xl text-lg text-[#272C34] font-bold px-2 '>Padel Buddy Court name</h5>
                       <h5 className='md:text-2xl text-lg text-[#272C34] font-bold'>$64<span className='text-gray-400 text-[12px] '>/game/player</span></h5>
                   </div>
                   <div className='mx-2 '>
                   <h2 className='pt-2 text-[#272C34] text-[12px] font-bold'> Location </h2>
                   <p className='text-[#6A7D95] text-[12px] font-semibold '>12 ABC London , New York London.</p>
                   </div>
                   <div className='flex mx-2 md:pt-8 pt-3'>
                       <div className='h-9 w-9 rounded-full bg-red-100 text-center pt-[6px] cursor-pointer'><i class="fa-solid fa-trash text-[#EB5757] "></i></div>
                       <div className='h-9 w-9 rounded-full bg-blue-200 text-center pt-[6px] mx-2 cursor-pointer'><i class="fa-solid fa-pen text-blue-500"></i></div>
                       <div className='my-2 flex'>
            <p className='md:px-3 text-[#272C34] text-[12px] pt-1'>Available</p>
            <div class="relative mx-2 inline-block w-12 mr-2 align-middle select-none transition duration-200 ease-in">
    <input type="checkbox" name="toggle" id="toggle" class="toggle-checkbox absolute block w-6 h-6 rounded-full   border-4 appearance-none cursor-pointer"/>
    <label for="toggle" class="toggle-label block  overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"></label>
</div>
</div>
                   </div>
               </div>
               </div>

               <div className='md:flex my-6'>
               <div className=' md:w-[30%] rounded-xl '>
                   <img src={bizcourt} alt='court img' className='w-full h-full ' /> 
               </div>
               <div className=' md:w-[70%] md:ml-3 '>
                   <div className='flex justify-between'>
                       <h5 className='md:text-2xl text-lg text-[#272C34] font-bold px-2 '>Padel Buddy Court name</h5>
                       <h5 className='md:text-2xl text-lg text-[#272C34] font-bold'>$64<span className='text-gray-400 text-[12px] '>/game/player</span></h5>
                   </div>
                   <div className='mx-2 '>
                   <h2 className='pt-2 text-[#272C34] text-[12px] font-bold'> Location </h2>
                   <p className='text-[#6A7D95] text-[12px] font-semibold '>12 ABC London , New York London.</p>
                   </div>
                   <div className='flex mx-2 md:pt-8 pt-3'>
                       <div className='h-9 w-9 rounded-full bg-red-100 text-center pt-[6px] cursor-pointer'><i class="fa-solid fa-trash text-[#EB5757] "></i></div>
                       <div className='h-9 w-9 rounded-full bg-blue-200 text-center pt-[6px] mx-2 cursor-pointer'><i class="fa-solid fa-pen text-blue-500"></i></div>
                       <div className='my-2 flex'>
            <p className='md:px-3 text-[#272C34] text-[12px] pt-1'>Available</p>
            <div class="relative mx-2 inline-block w-12 mr-2 align-middle select-none transition duration-200 ease-in">
    <input type="checkbox" name="toggle" id="toggle" class="toggle-checkbox absolute block w-6 h-6 rounded-full   border-4 appearance-none cursor-pointer"/>
    <label for="toggle" class="toggle-label block  overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"></label>
</div>
</div>
                   </div>
               </div>
               </div>

               <div className='md:flex my-6'>
               <div className=' md:w-[30%] rounded-xl '>
                   <img src={bizcourt} alt='court img' className='w-full h-full ' /> 
               </div>
               <div className=' md:w-[70%] md:ml-3 '>
                   <div className='flex justify-between'>
                       <h5 className='md:text-2xl text-lg text-[#272C34] font-bold px-2 '>Padel Buddy Court name</h5>
                       <h5 className='md:text-2xl text-lg text-[#272C34] font-bold'>$64<span className='text-gray-400 text-[12px] '>/game/player</span></h5>
                   </div>
                   <div className='mx-2 '>
                   <h2 className='pt-2 text-[#272C34] text-[12px] font-bold'> Location </h2>
                   <p className='text-[#6A7D95] text-[12px] font-semibold '>12 ABC London , New York London.</p>
                   </div>
                   <div className='flex mx-2 md:pt-8 pt-3'>
                       <div className='h-9 w-9 rounded-full bg-red-100 text-center pt-[6px] cursor-pointer'><i class="fa-solid fa-trash text-[#EB5757] "></i></div>
                       <div className='h-9 w-9 rounded-full bg-blue-200 text-center pt-[6px] mx-2 cursor-pointer'><i class="fa-solid fa-pen text-blue-500"></i></div>
                       <div className='my-2 flex'>
            <p className='md:px-3 text-[#272C34] text-[12px] pt-1'>Available</p>
            <div class="relative mx-2 inline-block w-12 mr-2 align-middle select-none transition duration-200 ease-in">
    <input type="checkbox" name="toggle" id="toggle" class="toggle-checkbox absolute block w-6 h-6 rounded-full   border-4 appearance-none cursor-pointer"/>
    <label for="toggle" class="toggle-label block  overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"></label>
</div>
</div>
                   </div>
               </div>
               </div>

      


                {/* pagination  */}

                <div className='flex justify-between mt-3 md:mt-9'>
               <nav aria-label="Page navigation example">
  <ul class="inline-flex items-center -space-x-px">
    <li>
      <a href="#" class="block py-2 px-3 ml-0 leading-tight text-gray-500  text-[12px]  rounded-l-lg  hover:bg-gray-100 hover:text-gray-700  ">
        <span class="sr-only">Previous</span>
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"></path></svg>
      </a>
    </li>
    <li>
      <a href="#" class="py-2 px-3 leading-tight text-[12px] hover:bg-gray-100 hover:text-gray-700  ">1</a>
    </li>
    <li>
      <a href="#" class="py-2 px-3 leading-tight text-gray-500  text-[12px]   hover:bg-gray-100 hover:text-gray-700  ">2</a>
    </li>
    <li>
      <a href="#" aria-current="page" class=" text-gray-500  py-2 px-3 leading-tight text-[12px]  hover:bg-blue-100 hover:text-blue-700  ">3</a>
    </li>
    <li>
      <a href="#" class="py-2 px-3 leading-tight text-gray-500  text-[12px]   hover:bg-gray-100 hover:text-gray-700  ">4</a>
    </li>
   
    <li>
      <a href="#" class="py-2 px-3 leading-tight text-gray-500  text-[12px]   hover:bg-gray-100 hover:text-gray-700  ">...</a>
    </li>
    <li>
      <a href="#" class="block py-2 px-3 leading-tight text-gray-500  text-[12px]  rounded-r-lg  hover:bg-gray-100 hover:text-gray-700  ">
        <span class="sr-only">Next</span>
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
      </a>
    </li>
  </ul>
</nav>
<h3 className='text-gray-500 text-[12px] mt-3'>1 of 729</h3>
</div>


 

            </div> : null }


           { showcal ?  <div> 
                 <BizAddNewCourt/> 
            </div> :null }
    </>
  )
}

export default BizManageCourt